import { ChangeDetectionStrategy, Component, computed } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { FormButtonComponent } from "app/core/ui/form-button-component";
import type { AuthFailureReason } from "../../../../loader-factory/src/models/auth.model";
import { AuthService } from "../auth.service";
import { AuthStore } from "../auth.store";

/** Presents the interactive authentication action and its retryable states. */
@Component({
  selector: "fof-auth-prompt",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormButtonComponent, MatProgressSpinnerModule],
  templateUrl: "./template.html",
  styleUrls: ["./style.scss"],
})
export class AuthPromptComponent {
  protected readonly isPending = this.authStore.isPending;
  protected readonly shouldPrompt = this.authStore.shouldPrompt;
  protected readonly attemptsExhausted = this.authStore.attemptsExhausted;
  protected readonly failureReason = computed<AuthFailureReason | null>(() => {
    const state = this.authStore.state();
    return state.status === "failed" ? state.reason : null;
  });

  constructor(
    private readonly authService: AuthService,
    private readonly authStore: AuthStore
  ) {}

  /** Requests an interactive authentication attempt. */
  protected authenticate(): void {
    this.authService.authenticate("interactive");
  }
}
